import styled from '@emotion/styled'
import { colors } from 'parameters/index'
import { useRange } from '../common/useRange'
import { BlockComponent } from 'lib'
import { ControlledInputProps } from '../../../../../../components/inputs/elements/types'
import { css } from '@emotion/react'
import { CornerMods } from 'components/styles/primitives/modifiers/shape/corners'
import { BrowserStyles } from 'components/styles/primitives/modifiers/browserHacks/disableAppearance'
import { ifRangeThumb } from 'components/styles/primitives/selectors/ifRangeThumb'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { circle } from 'components/styles/definitions/shapes'
import type { RangeOptions } from '../common/types'
import { RANGE_TRACK_COLOR } from '../common/utils'

export interface RangeInputProps extends ControlledInputProps<number> {
	options: RangeOptions
}

export const RangeInput: BlockComponent<RangeInputProps> = ({ name, options, onChange, value }) => {
	const { inputRef } = useRange(value)

	return (
		<Slider
			ref={inputRef}
			name={name}
			type="range"
			min={options.min}
			max={options.max}
			step={options.step}
			value={value}
			onChange={onChange}
		/>
	)
}

const thumbStyles = css`
	${circle('1.5rem')}
	background-color: ${colors.primaryGreen1};
	cursor: pointer;
`

const Slider = styled.input`
	${BrowserStyles.disableAll}
	${SizeMods.FullWidth}
	${CornerMods.FullyRounded};
	${ifRangeThumb(thumbStyles)};
	background-color: ${RANGE_TRACK_COLOR};
	height: 0.5rem;
	/**
		 * No Track styles are needed
		 * -moz-range-progress
		 * -ms-fill-lower
		 *
		 * background-color is set inline
		 * height does nothing if set on the root input (due to clipping)
		 * border radius does nothing if set on the root input (due to clipping)
		 */
`
